import { CartGateway } from '@/services/cart/cart.gateway';
import ApiBase from '@/services/ApiBase';
import { API_URL, getApiUrl } from '@/utils/api';

export class HttpCartGateway extends ApiBase implements CartGateway {
  static userCartUrl = getApiUrl(API_URL.USER, '/cart');

  async deleteProductFromCart({ storeId, partnumber }: { storeId: string, partnumber: string }) {
    return await this.api.postPromisedJSON(`${HttpCartGateway.userCartUrl}/${storeId}/product`, {
      partnumber,
      qty: 0,
    }, {
      guestToken: true,
      credentials: 'include'
    });
  }
}
